import { axios } from 'common/axios';

export const fetchIsUserAuthenticated = async (): Promise<any> => {
  const url = '/api/is-user-authenticated';
  const { data } = await axios.get(url);

  return data;
};

export const setCsrfToken = async (): Promise<any> => {
  const url = '/api/set-csrf-cookie';
  const { data } = await axios.get(url);

  return data;
};

export const loginUserPass = async ({
  username,
  password,
  tenantName,
}: {
  username: string;
  password: string;
  tenantName: string;
}): Promise<any> => {
  const url = '/api/login';
  const { data } = await axios.post(url, {
    username,
    password,
    tenant_name: tenantName,
  });

  return data;
};

export const forgotPassword = async (username: string): Promise<any> => {
  const url = '/api/forgot-password/';
  const { data } = await axios.post(url, { username });

  return data;
};

export const tokenLogin = async (token: string): Promise<any> => {
  const url = '/api/forticloud/token-login';
  const { data } = await axios.get(url, {
    params: {
      token,
    },
  });

  return data;
};

export const logoutUser = async (): Promise<any> => {
  const url = '/api/logout/';
  const { data } = await axios.get(url);

  return data;
};

export const certificateDownload = async (): Promise<any> => {
  const { data } = await axios.get('/api/auth/saml2/certificate/download', {
    responseType: 'blob',
  });

  return data;
};

export const getCertificateExists = async (): Promise<any> => {
  const { data } = await axios.get('/api/auth/saml2/certificate/exists');

  return data;
};

export const getAuthProviders = async (): Promise<any> => {
  const { data } = await axios.get('/api/auth/providers/');

  return data;
};

export const deleteAuthProvider = async (provider: any): Promise<any> => {
  const { data } = await axios.delete(`/api/auth/providers/${provider}/`);

  return data;
};

export const getAuthProvider = async (provider: any): Promise<any> => {
  const { data } = await axios.get(`/api/auth/providers/${provider}/`);

  return data;
};

export const updateAuthProvider = async (
  provider: any,
  providerDetails: any,
): Promise<any> => {
  const { data } = await axios.put(`/api/auth/providers/${provider}/`, {
    idp_certificate: providerDetails.idp_certificate,
    issuer_url: providerDetails.issuer_url,
    mechanism: providerDetails.mechanism,
    name: provider.name,
    saml_endpoint: providerDetails.saml_endpoint,
  });

  return data;
};

export const createAuthProvider = async (
  providerDetails: any,
): Promise<any> => {
  const { data } = await axios.post('/api/auth/providers/', {
    name: providerDetails.name,
    mechanism: providerDetails.mechanism,
    issuer_url: providerDetails.issuer_url,
    saml_endpoint: providerDetails.saml_endpoint,
    idp_certificate: providerDetails.idp_certificate,
  });

  return data;
};

export const getAuthError = async (): Promise<any> => {
  const { data } = await axios.get('/api/auth-error');

  return data;
};
